import React, { type CSSProperties } from "react";

import Home1x from "../../assets/icons/home@1x.webp";
import Home2x from "../../assets/icons/home@2x.webp";
import Home3x from "../../assets/icons/home@3x.webp";
import Menu1x from "../../assets/icons/menu@1x.webp";
import Menu2x from "../../assets/icons/menu@2x.webp";
import Menu3x from "../../assets/icons/menu@3x.webp";
import Select1x from "../../assets/icons/copy@1x.webp";
import Select2x from "../../assets/icons/copy@2x.webp";
import Select3x from "../../assets/icons/copy@3x.webp";

import { Button } from "./Button";
import type { ButtonKey } from "../VirtualGamepad";

interface TopButtonGroupProps {
  onTouchStart: (e: React.TouchEvent, buttonKey: ButtonKey) => void;
  onTouchEnd: (e: React.TouchEvent, buttonKey: ButtonKey) => void;
  onMouseDown: (e: React.MouseEvent, buttonKey: ButtonKey) => void;
  onMouseUp: (e: React.MouseEvent, buttonKey: ButtonKey) => void;
  containerStyle?: CSSProperties;
  buttonStyles?: Partial<Record<string, CSSProperties>>;
}

const buttonConfigs: {
  [key in Partial<ButtonKey>]?: { src1x: string; src2x: string; src3x: string };
} = {
  start: { src1x: Menu1x, src2x: Menu2x, src3x: Menu3x },
  home: { src1x: Home1x, src2x: Home2x, src3x: Home3x },
  select: { src1x: Select1x, src2x: Select2x, src3x: Select3x },
};

export const TopButtonGroup: React.FC<TopButtonGroupProps> = ({
  onTouchStart,
  onTouchEnd,
  onMouseDown,
  onMouseUp,
  containerStyle = {},
  buttonStyles = {},
}) => {
  return (
    <div style={{ ...baseStyles.topButtonsContainer, ...containerStyle }}>
      {["select", "home", "start"].map((buttonKey) => {
        const config = buttonConfigs[buttonKey as ButtonKey];
        if (!config) return null;
        return (
          <Button
            key={buttonKey}
            iconConfig={config}
            style={{
              ...baseStyles.button,
              ...buttonStyles[buttonKey],
            }}
            buttonKey={buttonKey as ButtonKey}
            onTouchStart={(e, key) => {
              onTouchStart(e, key);
            }}
            onMouseDown={(e, key) => {
              onMouseDown(e, key);
            }}
            onTouchEnd={onTouchEnd}
            onMouseUp={onMouseUp}
          />
        );
      })}
    </div>
  );
};

const baseStyles: { [key: string]: CSSProperties } = {
  button: {
    height: 48,
    width: 48,
    borderRadius: "50%",
  },
  topButtonsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 24,
  },
  pressed: {
    background: "rgba(255, 255, 255, 0.3)",
  },
};
